// extracted by mini-css-extract-plugin
export default {"Overlay":"OverlayModal_Overlay__rUxUA","ContentContainer":"OverlayModal_ContentContainer__tpC6g","Visible":"OverlayModal_Visible__7phrO"};